import { getCompanies } from 'adminPanel/api/companies';
import { Company } from 'adminPanel/types';
import { useEffect, useState } from 'react';

export const useCompanies = () => {
    const [companies, setCompanies] = useState<Company[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getCompanies()
            .then(setCompanies)
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return { companies, isLoading };
};
